import SignIn from "@/components/auth/SignInComponent";

export default [
	{
		path : '/',
		name : 'sign_in',
		meta : { layout: "auth", title: 'Sign In', auth: false },
		component : SignIn
	},
];